// extracted by mini-css-extract-plugin
export default {"container":"HeadMenuItem_container__TQpiL","img":"HeadMenuItem_img__qlWTc"};